export default class DeleteVoicemailRecording {
  constructor(context) {
    this.context = context;
  }

  run({ customerId, conversationItemId }) {
    this.context.gateways.voiceRecording.deleteVoicemailRecording(customerId, conversationItemId);
  }
}
